import { render } from "./MacmaporgCustomsDuties.vue?vue&type=template&id=7db20554&scoped=true"
import script from "./MacmaporgCustomsDuties.vue?vue&type=script&lang=js"
export * from "./MacmaporgCustomsDuties.vue?vue&type=script&lang=js"

import "./MacmaporgCustomsDuties.vue?vue&type=style&index=0&id=7db20554&lang=scss&scoped=true"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7db20554"]])

export default __exports__